module.exports = __webpack_public_path__ + "img/losing-muscle.a5149e59.svg";